import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('PurgeModel')
export class PurgeModel {

    @JsonProperty('purgeStartDate',String,true)
    purgeStartDate = '0';

    @JsonProperty('purgeEndDate',String,true)
    purgeEndDate = '0';

    @JsonProperty('purgeCycle',Number,true)
    purgeCycle = 0;

    @JsonProperty('usePurgeDateRange',Boolean,true)
    usePurgeDateRange = false;

    @JsonProperty('keys',[String],true)
    keys = [];

    @JsonProperty('uei',String,true)
    uei = '';

    @JsonProperty('unit',String,true)
    unit = '';

    @JsonProperty('extractListOfDeletedFiles',Boolean,true)
    extractListOfDeletedFiles = false;
}
